<template>
    <span class="c-lotus-only no-tooltip-icon" title="Viewable only by Lotus"><i class="fas fa-eye-slash"></i></span>
</template>





<script>
export default {

}
</script>





<style lang="scss" scoped>
//@use "/assets/sass/styles-version-1.scss" as *;

    .c-lotus-only
    {
		cursor: default;
    }
</style>